import {QuillModules} from "ngx-quill";
import {AbstractFormConfig} from "../abstract-form.config";

export class FormTextEditorConfig extends AbstractFormConfig {

  public placeholder: string = '';
  public keyDelay: number = 2000;
  public patchValueOnChange: boolean = true;
  public quillModules: QuillModules = FormTextEditorConfig.buildDefaultQuillConfig();
  public hiddenIfEmpty: boolean = false;

  constructor(init?: Partial<FormTextEditorConfig> | undefined) {
    super(init);
    Object.assign(this, init);
  }

  public static buildDefaultQuillConfig(): QuillModules {
    return {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{'direction': 'rtl'}],
      ],
      clipboard: {
        matchers: [
          [Node.ELEMENT_NODE, FormTextEditorConfig.sanitizeHtmlMatcher]
        ]
      }
    };
  }

  public static buildBasicQuillConfig(): QuillModules {
    return {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{'direction': 'rtl'}],
      ],
      clipboard: {
        matchers: [
          [Node.ELEMENT_NODE, FormTextEditorConfig.sanitizeHtmlMatcher]
        ]
      }
    };
  }

  public static buildEmptyQuillConfig(): QuillModules {
    return {
      toolbar: false,
      clipboard: {
        matchers: [
          [Node.ELEMENT_NODE, FormTextEditorConfig.sanitizeHtmlMatcher]
        ]
      }
    };
  }

  private static sanitizeHtmlMatcher = (node: any, delta: any): any => {
    const allowedTags: string[] = ['strong', 'b', 'em', 'i', 'u', 's', 'strike', 'del', 'span', 'p'];
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tagName: any = node.tagName.toLowerCase();
      if (!allowedTags.includes(tagName)) {
        const textContent: any = node.textContent || '';
        const Delta: any = (window as any).Quill?.import('delta');
        if (Delta) {
          return new Delta().insert(textContent);
        }
        return delta;
      }
    }
    return delta;
  };
}
